import { useAcceptIntroAsRequestor } from '@queries/introductions';
import { withAuthGate } from '@sunrise-ui/composites';
import { useSafeLocalSearchParams } from '@sunrise-ui/primitives';
import IntroPreviewView from '@templates/IntroPreviewView';
import { router } from 'expo-router';
import React from 'react';

function IntroPreviewScreen() {
  const { introId, uri } = useSafeLocalSearchParams<{
    introId: string;
    uri: string;
  }>();
  const { mutate: acceptIntro, isPending } = useAcceptIntroAsRequestor();

  const handleSave = async () => {
    acceptIntro(
      { uri, introId },
      {
        onSuccess: () => {
          router.navigate(`/intros/myIntros/pending/${introId}`);
        },
      },
    );
  };

  return <IntroPreviewView handleSave={handleSave} isSaving={isPending} />;
}

export default withAuthGate(IntroPreviewScreen);
